export default __webpack_public_path__ + "static/media/Baka.985c47cc.mp3";